import  icon  from '../../data/Img/7.png';
import img from '../Img/default.jpg'
import img2 from '../Img/c.jpg'


// all columns
export const ColumnsPendingOrder = [
  { label: "SL", visible: true },
  { label: "Order Id", visible: true },
  { label: "Customer Name", visible: true },
  { label: "Customer Type", visible: true },
  { label: "Waiter", visible: true },
  { label: "Table", visible: true },
  { label: "Pre-Order", visible: true },
  { label: "Pre Order Date", visible: true },
  { label: "Pre Order Time", visible: true },
  { label: "Order Date", visible: true },
  { label: "Amount", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsCategoryList = [
  { label: "SL", visible: true },
  { label: "Image", visible: true },
  { label: "Category Name", visible: true },
  { label: "Parent Menu", visible: true },
  { label: "Status", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsCustomerRating = [
  { label: "SL", visible: true },
  { label: "Title", visible: true },
  { label: "Name", visible: true },
  { label: "Review Text", visible: true },
  { label: "Rating", visible: true },
  { label: "Email Address", visible: true },
  { label: "Action", visible: true },
];
export const ColumnsCoponList = [
  { label: "SL", visible: true },
  { label: "Coupon Code", visible: true },
  { label: "Coupon Value", visible: true },
  { label: "Start Date", visible: true },
  { label: "End Date", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsSubscribeList = [
  { label: "SL", visible: true },
  { label: "Email Address", visible: true },
];

export const ColumnsBannerSetting = [
  { label: "SL", visible: true },
  { label: "Image", visible: true },
  { label: "Title", visible: true },
  { label: "Banner Size", visible: true },
  { label: "Status", visible: true },
  { label: "Action", visible: true },
];
export const ColumnsUserList = [
  { label: "SL", visible: true },
  { label: "Image", visible: true },
  { label: "User Name", visible: true },
  { label: "Email Address", visible: true },
  { label: "About", visible: true },
  { label: "Last Login", visible: true },
  { label: "Last Logout", visible: true },
  { label: "IP Address", visible: true },
  { label: "Status", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsManageEmployee= [
  { label: "SL No", visible: true },
  { label: "Image", visible: true },
  { label: "First Name", visible: true },
  { label: "Last Name", visible: true },
  { label: "Designation", visible: true },
  { label: "Phone", visible: true },
  { label: "Email Address", visible: true },
  { label: "Division", visible: true },
  { label: "Duty Type", visible: true },
  { label: "Hire Date", visible: true },
  { label: "Original Hire Date", visible: true },
  { label: "Termination Reason", visible: true },
  { label: "Voluntary Termination", visible: true },
  { label: "Re Hire Date", visible: true },
  { label: "Rate Type", visible: true },
  { label: "Pay Frequency", visible: true },
  { label: "Pay Frequency Text", visible: true },
  { label: "Hourly Rate 2", visible: true },
  { label: "Hourly Rate 3", visible: true },
  { label: "Home Department", visible: true },
  { label: "Department Text", visible: true },
  { label: "Supervisor Name", visible: true },
  { label: "Is Supervisor", visible: true },
  { label: "Supervisor Report", visible: true },
  { label: "Date of Birth", visible: true },
  { label: "Gender", visible: true },
  { label: "Material Status", visible: true },
  { label: "Ethnic Group", visible: true },
  { label: "EEO Class", visible: true },
  { label: "SSN", visible: true },
  { label: "Work in State", visible: true },
  { label: "Live in State", visible: true },
  { label: "Home Email", visible: true },
  { label: "Business Email", visible: true },
  { label: "Home Phone", visible: true },
  { label: "Business Phone", visible: true },
  { label: "Call Phone", visible: true },
  { label: "Emergency Contact", visible: true },
  { label: "Emergency Home Phone", visible: true },
  { label: "Emergency Work Phone", visible: true },
  { label: "Emergency Contact Relation", visible: true },
  { label: "Alter Emergency Contact", visible: true },
  { label: "Alter Emergency Home Phone", visible: true },
  { label: "Alter Emergency Work Phone", visible: true },
  { label: "Action", visible: true },

];

export const ColumnsPaymentMethodList = [
  { label: "SL", visible: true },
  { label: "Payment Method Name", visible: true },
  { label: "Status", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsTableList = [
  { label: "SL", visible: true },
  { label: "Table Name", visible: true },
  { label: "Icon", visible: true },
  { label: "Capacity", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsPaymentMethodSetup = [
  { label: "SL", visible: true },
  { label: "Payment Method Name", visible: true },
  { label: "Email Address/Location ID", visible: true },
  { label: "Merchant ID/Application ID", visible: true },
  { label: "Currency", visible: true },
  { label: "Mode", visible: true },
  { label: "Status", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsInboxMessage = [
  { label: "SL", visible: true },
  { label: "Sender Name", visible: true },
  { label: "Subject", visible: true },
  { label: "Message", visible: true },
  { label: "Date", visible: true },
  { label: "Status", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsShippingMethod = [
  { label: "SL", visible: true },
  { label: "Shipping Method Name", visible: true },
  { label: "City", visible: true },
  { label: "Shipping Rate", visible: true },
  { label: "Status", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsCustomerList= [
  { label: "SL", visible: true },
  { label: "Customer Name", visible: true },
  { label: "Email Address", visible: true },
  { label: "Address", visible: true },
  { label: "Mobile", visible: true },
  { label: "Country", visible: true },
  { label: "State", visible: true },
  { label: "City", visible: true },
  { label: "Street", visible: true },
  { label: "Building", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsUnitMeasurement= [
  { label: "SL", visible: true },
  { label: "Unit Name", visible: true },
  { label: "Short Name", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsIngredients= [
  { label: "SL", visible: true },
  { label: "Ingredients Name", visible: true },
  { label: "Unit Name", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsThirdPartyCustomers= [
  { label: "SL", visible: true },
  { label: "Company Name", visible: true },
  { label: "Address", visible: true },
  { label: "Commission", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsCardTerminal_l= [
  { label: "SL", visible: true },
  { label: "Card Terminal Name", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsBankList= [
  { label: "SL", visible: true },
  { label: "Bank Name", visible: true },
  { label: "A/C Name", visible: true },
  { label: "A/C Number", visible: true },
  { label: "Branch", visible: true },
  { label: "Balance", visible: true },
  { label: "Signature Picture", visible: true },
  { label: "Action", visible: true },
];
export const ColumnsShiftManagement= [
  { label: "SL", visible: true },
  { label: "Title", visible: true },
  { label: "Start Time", visible: true },
  { label: "End Time", visible: true },
  { label: "Last Date", visible: true },
  { label: "From", visible: true },
  { label: "Action", visible: true },
];


export const ColumnsAssignShiftManagement= [
  { label: "SL", visible: true },
  { label: "Title", visible: true },
  { label: "Total Employee", visible: true },
  { label: "Action", visible: true },
];
export const ColumnsChartOfAccount= [
  { label: "Head Code", visible: true },
  { label: "Head Name", visible: true },
  { label: "Parent Head", visible: true },
  { label: "Head Type", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsManageStoreTime= [
  { label: "SL", visible: true },
  { label: "Day", visible: true },
  { label: "Available On", visible: true },
  { label: "Closing Time", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsMenuSetting= [
  { label: "SL", visible: true },
  { label: "Menu Name", visible: true },
  { label: "Menu Slug", visible: true },
  { label: "Parent Menu", visible: true },
  { label: "Status", visible: true },
  { label: "Action", visible: true },
];
export const ColumnsSeoSetting= [
  { label: "SL", visible: true },
  { label: "Title", visible: true },
  { label: "Keyword", visible: true },
  { label: "Description", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsSocialSetting= [
  { label: "SL", visible: true },
  { label: "Title", visible: true },
  { label: "URL", visible: true },
  { label: "Select Icon", visible: true },
  { label: "Status", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsWidgetSetting= [
  { label: "SL", visible: true },
  { label: "Widget Name", visible: true },
  { label: "Widget Title", visible: true },
  { label: "Description", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsManageEmployeeSalary= [
  { label: "SL", visible: true },
  { label: "Employee Name", visible: true },
  { label: "Employee Id", visible: true },
  { label: "Total Salary", visible: true },
  { label: "Working Hour", visible: true },
  { label: "Working Period", visible: true },
  { label: "Payment Type", visible: true },
  { label: "Date", visible: true },
  { label: "Paid By", visible: true },
  { label: "Action", visible: true },
];
export const ColumnsBasicInformation= [
  { label: "SL", visible: true },
  { label: "Name", visible: true },
  { label: "Candidate Id", visible: true },
  { label: "Photograph", visible: true },
  { label: "Email Address", visible: true },
  { label: "SSN", visible: true },
  { label: "Phone", visible: true },
  { label: "Action", visible: true },
];
export const ColumnsPastExp= [
  { label: "SL", visible: true },
  { label: "Candidate Id", visible: true },
  { label: "Company Name", visible: true },
  { label: "Work Period", visible: true },
  { label: "Duties", visible: true },
  { label: "Supervisor", visible: true },
];
export const ColumnsEducationInfo= [
  { label: "SL", visible: true },
  { label: "Candidate Id", visible: true },
  { label: "Obtained Degree", visible: true },
  { label: "University", visible: true },
  { label: "CGPA", visible: true },
  { label: "Comments", visible: true },
];

export const ColumnsManageExpenses= [
  { label: "SL", visible: true },
  { label: "Expense Item Name", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsHotels= [
  { label: "SL", visible: true },
  { label: "Signature Picture", visible: true },
  { label: "Name", visible: true },
  { label: "Service Charge", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsCurrency= [
  { label: "SL", visible: true },
  { label: "Currency Name", visible: true },
  { label: "Currency Icon", visible: true },
  { label: "Designation", visible: true },
  { label: "Conversion Rate", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsCountry= [
  { label: "SL", visible: true },
  { label: "Country", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsCity= [
  { label: "SL", visible: true },
  { label: "Country", visible: true },
  { label: "State", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsArea= [
  { label: "SL", visible: true },
  { label: "State", visible: true },
  { label: "City", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsStationList= [
  { label: "SL", visible: true },
  { label: "Station Name", visible: true },
  { label: "Action", visible: true },
];
export const ColumnsStationAssign= [
  { label: "SL", visible: true },
  { label: "Station Name", visible: true },
  { label: "User", visible: true },
];

export const ColumnsVoucherApproval= [
  { label: "SL No.", visible: true },
  { label: "Voucher No", visible: true },
  { label: "Remark", visible: true },
  { label: "Debit", visible: true },
  { label: "Credit", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsCustomerType= [
  { label: "SL", visible: true },
  { label: "Type Name", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsFoodList = [
  { label: "SL", visible: true },
  { label: "Image", visible: true },
  { label: "Category Name", visible: true },
  { label: "Food Name", visible: true },
  { label: "Components", visible: true },
  { label: "Vat", visible: true },
  { label: "Status", visible: true },
  { label: "Change Status", visible: true },
  { label: "Pre Order", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsFoodVariant = [
  { label: "SL", visible: true },
  { label: "Variant Name", visible: true },
  { label: "Food Name", visible: true },
  { label: "Price", visible: true },
  { label: "Status", visible: true },
  { label: "Status Action", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsFoodavailable = [
  { label: "SL", visible: true },
  { label: "Food Name", visible: true },
  { label: "Available Day", visible: true },
  { label: "Available Time", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsMenuType = [
  { label: "SL", visible: true },
  { label: "Menu Type", visible: true },
  { label: "Icon", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsAddOnsList = [
  { label: "SL", visible: true },
  { label: "Group Name", visible: true },
  { label: "Status", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsPreOrderList = [
  { label: "SL", visible: true },
  { label: "Invoice No", visible: true },
  { label: "Customer Name", visible: true },
  { label: "Customer Type", visible: true },
  { label: "Waiter", visible: true },
  { label: "Table", visible: true },
  { label: "Pre-Order", visible: true },
  { label: "Pre Order Date", visible: true },
  { label: "Pre Order Time", visible: true },
  { label: "Order Date", visible: true },
  { label: "Amount", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsPreOrderDateList = [
  { label: "SL", visible: true },
  { label: "Pre Date", visible: true },
  { label: "Time Slots", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsOrderList = [
  { label: "SL", visible: true },
  { label: "Invoice No", visible: true },
  { label: "Customer Name", visible: true },
  { label: "Waiter", visible: true },
  { label: "Table", visible: true },
  { label: "State", visible: true },
  { label: "Order Date", visible: true },
  { label: "Amount", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsQROrder = [
  { label: "SL", visible: true },
  { label: "Invoice", visible: true },
  { label: "Customer Name", visible: true },
  { label: "Customer Type", visible: true },
  { label: "Waiter", visible: true },
  { label: "Table No", visible: true },
  { label: "Payment Status", visible: true },
  { label: "Order Date", visible: true },
  { label: "Amount", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsOnlineOrder = [
  { label: "SL", visible: true },
  { label: "Invoice", visible: true },
  { label: "Customer Name", visible: true },
  { label: "Delivery Method Name", visible: true },
  { label: "Delivery Date & Time", visible: true },
  { label: "Waiter", visible: true },
  { label: "Table No", visible: true },
  { label: "Payment Status", visible: true },
  { label: "Order Date", visible: true },
  { label: "Amount", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsTodayOrder = [
  { label: "SL", visible: true },
  { label: "Invoice", visible: true },
  { label: "Customer Name", visible: true },
  { label: "Customer Type", visible: true },
  { label: "Waiter", visible: true },
  { label: "Table No", visible: true },
  { label: "Order Date", visible: true },
  { label: "Amount", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsClosingBalance = [
  { label: "SL No.", visible: true },
  { label: "Payment Type", visible: true },
  { label: "Total Price", visible: true },
];

export const ColumnsReservation = [
  { label: "SL", visible: true },
  { label: "Customer Name", visible: true },
  { label: "Table No.", visible: true },
  { label: "No.of Person", visible: true },
  { label: "Start Time", visible: true },
  { label: "End Time", visible: true },
  { label: "Date", visible: true },
  { label: "Status", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsInterview= [
  { label: "SL No", visible: true },
  { label: "Name", visible: true },
  { label: "Candidate Id", visible: true },
  { label: "Job Position", visible: true },
  { label: "Interview Date", visible: true },
  { label: "Viva Marks", visible: true },
  { label: "Written Total Marks", visible: true },
  { label: "MCQ Total Marks", visible: true },
  { label: "Total Marks", visible: true },
  { label: "Selection", visible: true },
];

export const ColumnsDepartment= [
  { label: "SL No", visible: true },
  { label: "Department Name", visible: true },
];
export const ColumnsLeaveApp= [
  { label: "SL No", visible: true },
  { label: "Name", visible: true },
  { label: "Leave Type", visible: true },
  { label: "Application Start Date", visible: true },
  { label: "Application End Date", visible: true },
  { label: "Approved Start Date", visible: true },
  { label: "Approved End Date", visible: true },
  { label: "Days", visible: true },
  { label: "Approved Day", visible: true },
];
export const ColumnsGrantLoan= [
  { label: "SL", visible: true },
  { label: "Name", visible: true },
  { label: "Permitted By", visible: true },
  { label: "Loan No.", visible: true },
  { label: "Amount", visible: true },
  { label: "Interest Percentage", visible: true },
  { label: "Installment Period", visible: true },
  { label: "Repayment Total", visible: true },
  { label: "Approved Date", visible: true },
  { label: "Repayment Form", visible: true },
];
export const ColumnsManageGrantLoan= [
  { label: "SL", visible: true },
  { label: "Name", visible: true },
  { label: "Permitted By", visible: true },
  { label: "Loan No.", visible: true },
  { label: "Amount", visible: true },
  { label: "Interest Percentage", visible: true },
  { label: "Installment Period", visible: true },
  { label: "Repayment Total", visible: true },
  { label: "Approved Date", visible: true },
  { label: "Repayment Form", visible: true },
  { label: "Action", visible: true },
];
export const ColumnsLoanInstallment= [
  { label: "SL", visible: true },
  { label: "Name", visible: true },
  { label: "Employee Id", visible: true },
  { label: "Loan No.", visible: true },
  { label: "Installment Amount", visible: true },
  { label: "Payment", visible: true },
  { label: "Date", visible: true },
  { label: "Receiver", visible: true },
  { label: "Install No", visible: true },
  { label: "Notes", visible: true },
];
export const ColumnsManageLoanInstallment= [
  { label: "SL", visible: true },
  { label: "Name", visible: true },
  { label: "Employee Id", visible: true },
  { label: "Loan No.", visible: true },
  { label: "Installment Amount", visible: true },
  { label: "Payment", visible: true },
  { label: "Date", visible: true },
  { label: "Receiver", visible: true },
  { label: "Install No", visible: true },
  { label: "Notes", visible: true },
  { label: "Action", visible: true },
];
export const ColumnsManageLeaveApp= [
  { label: "SL No", visible: true },
  { label: "Name", visible: true },
  { label: "Leave Type", visible: true },
  { label: "Application Start Date", visible: true },
  { label: "Application End Date", visible: true },
  { label: "Approved Start Date", visible: true },
  { label: "Approved End Date", visible: true },
  { label: "Days", visible: true },
  { label: "Approved Day", visible: true },
  { label: "Action", visible: true },
];
export const ColumnsWeeklyLeave= [
  { label: "SL", visible: true },
  { label: "Weekly Leave Day", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsHoliday= [
  { label: "SL", visible: true },
  { label: "Holiday Name", visible: true },
  { label: "From", visible: true },
  { label: "To", visible: true },
  { label: "Numbers of Days", visible: true },
];

export const ColumnsLeaveType= [
  { label: "ID", visible: true },
  { label: "Type Name", visible: true },
  { label: "Total Leave Days", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsManageHoliday= [
  { label: "SL", visible: true },
  { label: "Holiday Name", visible: true },
  { label: "From", visible: true },
  { label: "To", visible: true },
  { label: "Numbers of Days", visible: true },
  { label: "Action", visible: true },
];
export const ColumnsManageDepartment= [
  { label: "SL No", visible: true },
  { label: "Department Name", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsManageInterview= [
  { label: "SL No", visible: true },
  { label: "Name", visible: true },
  { label: "Candidate Id", visible: true },
  { label: "Job Position", visible: true },
  { label: "Interview Date", visible: true },
  { label: "Viva Marks", visible: true },
  { label: "Written Total Marks", visible: true },
  { label: "MCQ Total Marks", visible: true },
  { label: "Total Marks", visible: true },
  { label: "Selection", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsUnavailableList = [
  { label: "SL", visible: true },
  { label: "Unavailable Date", visible: true },
  { label: "Available Time", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsCateringInquiry = [
  { label: "SL", visible: true },
  { label: "Name", visible: true },
  { label: "No.of Person", visible: true },
  { label: "Contact No", visible: true },
  { label: "Date", visible: true },
  { label: "Status", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsPurchase = [
  { label: "SL", visible: true },
  { label: "Invoice no.", visible: true },
  { label: "Supplier Name", visible: true },
  { label: "Date", visible: true },
  { label: "Price", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsNewAward= [
  { label: "SL No", visible: true },
  { label: "Award Name", visible: true },
  { label: "Award Description", visible: true },
  { label: "Gift Item", visible: true },
  { label: "Date", visible: true },
  { label: "Employee Name", visible: true },
  { label: "Award By", visible: true },
];

export const ColumnsCandidateShortlist= [
  { label: "SL No", visible: true },
  { label: "Name", visible: true },
  { label: "Candidate Id", visible: true },
  { label: "Job Position", visible: true },
  { label: "Shortlist Date", visible: true },
  { label: "Interview Date", visible: true },
];

export const ColumnsCandidateSelection= [
  { label: "SL", visible: true },
  { label: "Name", visible: true },
  { label: "Candidate Id", visible: true },
  { label: "Employee Id", visible: true },
  { label: "Position", visible: true },
  { label: "Selection Terms", visible: true },
];

export const ColumnsManageCandidateSelection= [
  { label: "SL", visible: true },
  { label: "Name", visible: true },
  { label: "Candidate Id", visible: true },
  { label: "Employee Id", visible: true },
  { label: "Position", visible: true },
  { label: "Selection Terms", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsManageCandidateShortlist= [
  { label: "SL No", visible: true },
  { label: "Name", visible: true },
  { label: "Candidate Id", visible: true },
  { label: "Job Position", visible: true },
  { label: "Shortlist Date", visible: true },
  { label: "Interview Date", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsAwardController= [
  { label: "SL No", visible: true },
  { label: "Award Name", visible: true },
  { label: "Award Description", visible: true },
  { label: "Gift Item", visible: true },
  { label: "Date", visible: true },
  { label: "Employee Name", visible: true },
  { label: "Award By", visible: true },
  { label: "Action", visible: true },
];


export const ColumnsExpenses = [
  { label: "Supplier Name", visible: true },
  { label: "Type", visible: true },
  { label: "Date", visible: true },
  { label: "Amount", visible: true },
  { label: "Action", visible: true },
];
export const ColumnsExpenses22 = [
  { label: "Expense Item Name", visible: true },
  { label: "Date", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsLoanReport = [
  { label: "SL", visible: true },
  { label: "Name", visible: true },
  { label: "Employee Id", visible: true },
  { label: "Total Loan", visible: true },
  { label: "Total Amount", visible: true },
  { label: "Repayment Total", visible: true },
];

export const ColumnsProduction = [
  { label: "SL", visible: true },
  { label: "Food Name", visible: true },
  { label: "Variant Name", visible: true },
  { label: "Price", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsRoleList = [
  { label: "SL", visible: true },
  { label: "Role Name", visible: true },
  { label: "Description", visible: true },
  { label: "Action", visible: true },
];
export const ColumnsAssignRole = [
  { label: "SL", visible: true },
  { label: "User Name", visible: true },
  { label: "Role Name", visible: true },
  { label: "Action", visible: true },
];

export const ColumnsSupplier = [
  { label: "SL", visible: true },
  { label: "Supplier Name", visible: true },
  { label: "Email Address", visible: true },
  { label: "Mobile", visible: true },
  { label: "Address", visible: true },
  { label: "Balance", visible: true },
  { label: "Action", visible: true },
];


export const ColumnsDesignation = [
  { label: "SL", visible: true },
  { label: "Position", visible: true },
  { label: "Details", visible: true },
];

export const ColumnsSalaryType = [
  { label: "SL No", visible: true },
  { label: "Salary Type", visible: true },
  { label: "", visible: true },
];

export const ColumnsPackageFood = [
  { label: "SL", visible: true },
  { label: "Used Items", visible: true },
  { label: "Qnty", visible: true },
  { label: "Lost Price", visible: true },
  { label: "Note", visible: true },
];
export const ColumnsPurchaseFood = [
  { label: "SL", visible: true },
  { label: "Checked By", visible: true },
  { label: "Used Items", visible: true },
  { label: "Qnty", visible: true },
  { label: "Lost Price", visible: true },
  { label: "Note", visible: true },
  { label: "Date", visible: true },
];
export const ColumnsFoodName = [
  { label: "SL", visible: true },
  { label: "Checked By", visible: true },
  { label: "Used Items", visible: true },
  { label: "Variant Name", visible: true },
  { label: "Qnty", visible: true },
  { label: "Lost Price", visible: true },
  { label: "Note", visible: true },
  { label: "Date", visible: true },
];
export const ColumnsSalarySetup = [
  { label: "SL No", visible: true },
  { label: "Employee Name", visible: true },
  { label: "Employee Id", visible: true },
  { label: "Salary Type", visible: true },
  { label: "Date", visible: true },
];
export const ColumnsManageSalarySetup = [
  { label: "SL No", visible: true },
  { label: "Employee Name", visible: true },
  { label: "Employee Id", visible: true },
  { label: "Salary Type", visible: true },
  { label: "Date", visible: true },
  { label: "Action", visible: true },
];
export const ColumnsManageSalaryType = [
  { label: "SL No", visible: true },
  { label: "Salary Type", visible: true },
  { label: "", visible: true },
  { label: "Action", visible: true },
  
];

export const ColumnsManageGenerate = [
  { label: "SL No", visible: true },
  { label: "Employee Name", visible: true },
  { label: "Employee Id", visible: true },
  { label: "Name", visible: true },
  { label: "Generate Date", visible: true },
  { label: "Start Date", visible: true },
  { label: "End Date", visible: true },
  { label: "Generated By", visible: true },
  
];


export const ColumnsOutOfIngredient = [
  { label: "Ingredients", visible: true },
  { label: "Qnty", visible: true },
];


export const ColumnsPurchaseReport = [
  { label: "Invoice no.", visible: true },
  { label: "Supplier Name", visible: true },
  { label: "Purchase Date", visible: true },
  { label: "Total Amount", visible: true },
];

export const ColumnsVoucherReport = [
  { label: "Voucher No", visible: true },
  { label: "Description", visible: true },
  { label: "Date", visible: true },
  { label: "Amount", visible: true },
];

export const ColumnsSalaryManageGenerate = [
  { label: "SL No", visible: true },
  { label: "Employee Name", visible: true },
  { label: "Employee Id", visible: true },
  { label: "Name", visible: true },
  { label: "Generate Date", visible: true },
  { label: "Start Date", visible: true },
  { label: "End Date", visible: true },
  { label: "Generated By", visible: true },
  { label: "Action", visible: true },
  
];
export const ColumnsProfitLoss = [
  { label: "Head Name", visible: true },
  { label: "Amount", visible: true },
];

export const ColumnsCashBook = [
  { label: "SL", visible: true },
  { label: "Voucher No", visible: true },
  { label: "Voucher Type", visible: true },
  { label: "Head Name", visible: true },
  { label: "Date", visible: true },
  { label: "Debit", visible: true },
  { label: "Credit", visible: true },
  { label: "Balance", visible: true },
];


export const ColumnsStockReport = [
  { label: "Food Name", visible: true },
  { label: "In Quantity", visible: true },
  { label: "Out Quantity", visible: true },
  { label: "Stock", visible: true },
];

export const ColumnsStockReportStation = [
  { label: "Ingredient Name", visible: true },
  { label: "In Quantity", visible: true },
  { label: "Out Quantity", visible: true },
  { label: "Stock", visible: true },
];

export const ColumnsSalesReport = [
  { label: "Invoice No.", visible: true },
  { label: "Customer Name", visible: true },
  { label: "Sale Date", visible: true },
  { label: "Payment Method", visible: true },
  { label: "Total Order", visible: true },
  { label: "Vat/Tax", visible: true },
  { label: "Service Charge", visible: true },
  { label: "Discount", visible: true },
  { label: "Total Amount", visible: true },
];


export const ColumnsItemSalesReport = [
  { label: "Items Name", visible: true },
  { label: "Variant Name", visible: true },
  { label: "Quantity", visible: true },
  { label: "Total Amount", visible: true },
];

export const ColumnsItemSalesReportFiltering = [
  { label: "Invoice No.", visible: true },
  { label: "Customer Name", visible: true },
  { label: "Waiter", visible: true },
  { label: "Sales Type", visible: true },
  { label: "Sale Date", visible: true },
  { label: "Total Discount", visible: true },
  { label: "Third Party Commission", visible: true },
  { label: "Total Amount", visible: true },
];


export const ColumnsItemCahier = [
  { label: "SL", visible: true },
  { label: "User", visible: true },
  { label: "Date", visible: true },
  { label: "Counter Number", visible: true },
  { label: "Opening Balance", visible: true },
  { label: "Closing Balance", visible: true },
  { label: "Action", visible: true },
];


export const ColumnsItemServiceCharge = [
  { label: "Order Id", visible: true },
  { label: "Service Charge", visible: true },
];
export const ColumnsWaiter = [
  { label: "Waiter Name", visible: true },
  { label: "Total Amount", visible: true },
];
export const ColumnsStation = [
  { label: "Kitchen Name", visible: true },
  { label: "Total Amount", visible: true },
];

export const ColumnsDeliveryType = [
  { label: "Delivery Type", visible: true },
  { label: "Total Amount", visible: true },
];

export const ColumnsCashier = [
  { label: "Cashier Name", visible: true },
  { label: "Total Amount", visible: true },
];

export const ColumnsSaleByTable = [
  { label: "Table", visible: true },
  { label: "Total", visible: true },
  { label: "View", visible: true },
];

export const ColumnsSalesReportByDate = [
  { label: "Food Name", visible: true },
  { label: "Variant Name", visible: true },
  { label: "Date", visible: true },
  { label: "Quantity", visible: true },
  { label: "Price", visible: true },
  { label: "Total Amount", visible: true },
];

export const ColumnsCommission = [
  { label: "Waiter", visible: true },
  { label: "Commission", visible: true },
  { label: "Total", visible: true },
];

// all data
export const DataPendingOrder = [
  {
    sl: 19,
    order_id: 13757,
    customer_name: "Melody Macy",
    customer_type: "Take Away / Pickup",
    waiter: "Waiter1",
    table: "Table1",
    pre_order: "N",
    pre_order_date: "23/11/2023",
    pre_order_time: "4:30",
    order_date: "23/11/2023",
    amount: 1500,
  },
  {
    sl: 20,
    order_id: 13760,
    customer_name: "Melody Macy",
    customer_type: "Take Away / Pickup",
    waiter: "Waiter2",
    table: "Table2",
    pre_order: "N",
    pre_order_date: "24/7/2024",
    pre_order_time: "7:30",
    order_date: "23/11/2023",
    amount: 1500,
  },
];

export const DataCategoryList = [
  {
    sl: 19,
    img: img,
    categoryr_type: "Signature Dishes	",
    parent_menu: "parent_menu 1",
    status: "Active",
  },
  {
    sl: 20,
    img: img,
    categoryr_type: "Signature Dishes	",
    parent_menu: "parent_menu 2",
    status: "Inactive",
  },
];

export const DataManageEmployee = [
  {
    sl: 19,
    img: img,
    categoryr_type: "Walid",
    parent_menu: "Shalaby	",
    Desgination: "Delivery	",
    phone: "012345679	",
    email: "demochef1@instasme.com		",
    divison: "Delivery Driver	",
    duty_type: "Full Time	",
    hire_date: "2023-06-13	",
    original_date: "2023-06-13	",
    terminaton_date: "2023-06-13	",
    terminaton_reason: "2023-06-13	",
    voulntary_terminaton: "1",
    re_hire_date: "2023-06-13	",
    rate_type: "2023-06-13	",
    rate: 1000,
    pay_freq: 'Monthly',
    pay_freq_text: 'Monthly',
    Hourly_rate2: '0',
    Hourly_rate3: '0',
    home_dep: '',
    dep_text: '',
    super_name: '1',
    is: '',
    report: '',
    date_of_birth: "2023-06-13	",
    gender: "Male",
    material: "Single",
    ethnic_group: "",
    eeo_class: "",
    ssn: "",
    work_in_state: "",
    live_in_state: "",
    home_email: "",
    business_email: "",
    home_phone: "123546789",
    business_phone: "123546789",
    call_phone: "123546789", 
    emergency_contact: "123546789", 
    emergency_tel: "123546789", 
    emergency_tel2: "123546789", 
    emergency_tel_rel: "123546789", 
  
  },
];

export const DataPaymentMethodList = [
  {
    sl: 19,
    patment_method_name: "Two Checkout",
    parent_menu: "parent_menu 1",
    status: "Active",
  },
  {
    sl: 20,
    patment_method_name: "Stripe Payment",
    parent_menu: "parent_menu 2",
    status: "Inactive",
  },
];
export const DataTableList = [
  {
    sl: 19,
    table_name: "G8-A	",
    icon: icon, 
    capacity: 8,
  },
  {
    sl: 20,
    table_name: "G8-B	",
    icon: icon,
    capacity: 4,
  },
];

export const DataPaymentMethodSetup = [
  {
    sl: 19,
    patment_method_name: "Two Checkout",
    email:'	ainalcse@gmail.com',
    id:'sandbox-5rd4uUC2yAz7LWDaalyJAOEsH2rxrqVB	',
    currency:'BDT	',
    mode: "Test Mode	",
    status: "Active",
  },
  {
    sl: 19,
    patment_method_name: "Paytm Payments	",
    email:'karmadorji@gmail.com	',
    id:'002020000000001	',
    currency:'USD		',
    mode: "Test Mode	",
    status: "Inactive",
  },
];

export const DataShippingMethod = [
  {
    sl: 19,
    shipping_method_name: "Locanda Museum Hotel	",
    City:'Steigenberger Hotel Cairo Alex Rd	',
    Sipping_Rate:16.00,
    status: "Active",
  },
  {
    sl: 19,
    shipping_method_name: "Locanda Museum Hotel	",
    City:'Locanda Museum Hotel',
    Sipping_Rate:10.00,
    status: "Inactive",
  },
];

export const DataCustomerList = [
  {
    sl: 19,
    customer_name: "Antony Polack	",
    email:'demo@customer.com	',
    mobile:"123456789	",
    Address: "Begining - Cario Alexandria Desert Rd 12556 Oasis Hotel Reception	",
    country:'Egypt',
    state:'Giza	',
    city:'Oasis Hotel	',
    street:'',
    Building:'',
  },
  {
    sl: 20,
    customer_name: "Hazem Ismaiel	",
    email:'Ahmd5555@gmail.com	',
    mobile:"123456789	",
    Address: "Cairo alexandria desert road Steinberg hote cairo pyramids 1313	",
    country:'Egypt',
    state:'Giza	',
    city:'Cairo Pyramids Hotel	',
    street:'',
    Building:'',
  },
];

export const DataUnitMeasurement= [
  {
    sl: 19,
    Unit_name: "Grams	",
    short_name: "Grams	",
  },
  {
    sl: 20,
    Unit_name: "Piece		",
    short_name: "Pcs.		",
  },
];

export const DataIngredients= [
  {
    sl: 19,
    Ingredients_name: "Red Bull		",
    Unit_name: "Piece		",
  },
  {
    sl: 20,
    Ingredients_name: "Fanta",
    Unit_name: "Piece		",
  },
];

export const DataThirdPartyCustomers= [
  {
    sl: 19,
    customer_name: "Antony Polack	",
    Address: "Begining - Cario Alexandria Desert",
    Commission:18.00,
  },
];

export const DataCardTerminal= [
  {
    sl: 19,
    Card: "Visa-Master Terminal	",
  },
];

export const DataBankList= [
  {
    sl: 19,
    bank_name: "Brac Bank",
    ac_name:"	Ainal Haque",
    ac_num:"110535764655",
    branch:"Mirpur 10	",
    balance:"0",
    singature_pic:img2,
  },
  {
    sl: 19,
    bank_name: "City Bank",
    ac_name:"Kamal Hassan	",
    ac_num:"3869583	",
    branch:"Uttara	",
    balance:"0",
    singature_pic:img2,
  },
];

export const DataChartOfAccounts= [
  {
    sl: 1,
    bank_name: "Assets	",
    ac_name:"	COA	",
    ac_num:"A",
  },
  {
    sl: 2,
    bank_name: "Expense	",
    ac_name:"	Assets	",
    ac_num:"E",
  },
];


export const DataManageEmployeeSalary= [
  {
    sl: 1,
    bank_name: "Mostafa	",
    ac_name:"	EZYN3GVJ		",
    ac_num:"0",
    ac_num2:"0:00",
  },
];


export const DataBasicInformation= [
  {
    sl: 1,
    bank_name: "Eihab Salem		",
    ac_name:"	16304688503269L			",
    ac_num:"Salem@gmail.com	",
    ac_num2:"123456789",
  },
];

export const DataManageExpenses= [
  {
    sl: 1,
    bank_name: "Transportation	",
  },
];

export const DataHotels= [
  {
    sl: 19,
    singature_pic:img2,
    bank_name: "Grand Museum Pyramids Inn	",
    ac_name:"50",
  },
  {
    sl: 19,
    singature_pic:img2,
    bank_name: "Grand Museum Pyramids Inn	",
    ac_name:"50",
  },
];

export const DataCurrency= [
  {
    sl: 19,
    currency_name: "EGP",
    currency_icon: "LE	",
    Designation: "Left	",
    Conversion:1.0,
  },
];

export const DataCountry= [
  {
    sl: 19,
    currency_name: "Egypt",
  },
];

export const DataCity= [
  {
    sl: 19,
    currency_name: "Egypt",
    state: "Giza",
  },
];

export const DataArea= [
  {
    sl: 19,
    state: "Giza",
    city: "Locanda Museum Hotel	",
  },
];
export const DataStationList= [
  {
    sl: 19,
    Card: "Sandwiches	",
  },
  {
    sl: 20,
    Card: "Central Kitchen		",
  },
];
export const DataStationAssign= [
  {
    sl: 19,
    StationName: "Sandwiches	",
    User: "Mostafa	",
  },
  {
    sl: 20,
    StationName: "Central Kitchen		",
    User: "Mostafa	",
  },
];

export const DataVoucherApproval= [
  {
    sl: 19,
    StationName: "6555654",
    User: "Remark	",
    Debit: 75.00,
    Credit: 105.00,
  },
];

export const DataCustomerType = [
  {
    sl: 19,
    type_name: "QR Customer	",
  },
  {
    sl: 20,
    type_name: "Third Party Platform	",
  },
  {
    sl: 21,
    type_name: "Online Customer	",
  },
  {
    sl: 22,
    type_name: "Dine In		",
  },
];

export const DataFoodList = [
  {
    sl: 19,
    img: img,
    categoryr_type: "Signature Dishes	",
    parent_menu: "2 BBQ Lamb Chops	",
    comp: "Components 1",
    ChangStatus: "",
    pre: "No",
    status: "Inactive",
    vat:0
  },
  {
    sl: 20,
    img: img,
    categoryr_type: "Signature Dishes	",
    parent_menu: "1 BBQ Lamb Chops	",
    comp: "Components 1",
    ChangStatus: "",
    pre: "Yes",
    status: "Active",
    vat:50
  },
];

export const DataFoodavailable = [
  {
    sl: 19,
    parent_menu: "2 BBQ Lamb Chops	",
    time:'12:00:00-23:00:00',
    day:'Tuesday	'
  },
];

export const DataMenuType = [
  {
    sl: 19,
    parent_menu: "BBQ	",
    Icon:'./application/modules/itemmanage/assets/images/2023-02-08/e.jpg	',
  },
];

export const DataAddOnsList = [
  {
    sl: 19,
    parent_menu: "Foul & Falafel		",
    status:'Active',
  },
];

export const DataFoodVariant = [
  {
    sl: 19,
    img: img,
    categoryr_type: "Signature Dishes	",
    parent_menu: "2 BBQ Lamb Chops	",
    comp: "Components 1",
    ChangStatus: "",
    pre: "No",
    status: "Inactive",
    vat:390
  },
  {
    sl: 20,
    img: img,
    categoryr_type: "Signature Dishes	",
    parent_menu: "1 BBQ Lamb Chops	",
    comp: "Components 1",
    ChangStatus: "",
    pre: "Yes",
    status: "Active",
    vat:390
  },
];


export const DataOrderList = [
  {
    sl: 19,
    invoice_no: 13757,
    customer_name: "	Melody Macy",
    waiter: "Waiter1	",
    table: "Table1",
    state: "Served",
    order_date: "23/11/2023",
    amount: 1500,
  },
  {
    sl: 20,
    invoice_no: 13547,
    customer_name: "Brian Cox",
    waiter: "Waiter2",
    table: "Table2",
    state: "Pending",
    order_date: "8/7/2024",
    amount: 1750,
  },
  {
    sl: 21,
    invoice_no: 1546,
    customer_name: "Olivia Wild",
    waiter: "Waiter3",
    table: "Table4",
    state: "Cancelled",
    order_date: "8/7/2024",
    amount: 1750,
  },
];

export const DataPreOrderDateList = [
  {
    sl: 19,
    Pre_date: "23/11/2023",
    time_slots: "4:30",
  },
  {
    sl: 20,
    Pre_date: "23/11/2024",
    time_slots: "7:58",
  },
];

export const DataQROrder = [
  {
    sl: 19,
    invoice: 13757,
    customer_name: "Melody Macy",
    customer_type: "QR Customer",
    waiter: "Waiter1",
    table: "Table1",
    payment_status: "Unpaid",
    order_date: "2024-07-09	",
    amount: 1500,
  },
  {
    sl: 20,
    invoice: 15659,
    customer_name: "Brian Cox",
    customer_type: "Dine In",
    waiter: "Waiter2",
    table: "Table3",
    payment_status: "Paid",
    order_date: "2023-08-01",
    amount: 1250,
  },
  {
    sl: 21,
    invoice: 13757,
    customer_name: "Olivia Wild",
    customer_type: "QR Customer",
    waiter: "Waiter4",
    table: "Table5",
    payment_status: "Unpaid",
    order_date: "2024-06-08	",
    amount: 850,
  },
];

export const DataOnlineOrder = [
  {
    sl: 1,
    invoice: "INV-001",
    customer_name: "John Doe",
    delivery_method_name: "Home Delivery",
    delivery_date_time: "24/7/2024, 5:00 PM",
    waiter: "Waiter1",
    table_no: "N/A",
    payment_status: "Paid",
    order_date: "24/7/2024",
    amount: 120.0,
  },
  {
    sl: 2,
    invoice: "INV-002",
    customer_name: "Jane Smith",
    delivery_method_name: "Pickup",
    delivery_date_time: "24/7/2024, 6:00 PM",
    waiter: "Waiter2",
    table_no: "N/A",
    payment_status: "Pending",
    order_date: "24/7/2024",
    amount: 75.5,
  },
  {
    sl: 3,
    invoice: "INV-003",
    customer_name: "Jane Smith",
    delivery_method_name: "Pickup",
    delivery_date_time: "1/6/2024, 4:03 PM",
    waiter: "Waiter3",
    table_no: "N/A",
    payment_status: "Unpaid",
    order_date: "24/7/2024",
    amount: 750.1,
  },
];

export const DataTodayOrder = [
  {
    sl: 1,
    invoice: "INV-001",
    customer_name: "John Doe",
    customer_type: "QR Customer",
    waiter: "Waiter1",
    table_no: "N/A",
    order_date: "24/7/2024",
    amount: 120.0,
  },
  {
    sl: 2,
    invoice: "INV-002",
    customer_name: "Jane Smith",
    customer_type: "Dine In",
    waiter: "Waiter2",
    table_no: "N/A",
    order_date: "24/7/2024",
    amount: 75.5,
  },
  {
    sl: 3,
    invoice: "INV-003",
    customer_name: "Jane Smith",
    customer_type: "QR Customer",
    waiter: "Waiter3",
    table_no: "N/A",
    order_date: "24/7/2024",
    amount: 750.1,
  },
];

export const DataClosingBalance = [
  {
    sl: 1,
    payment_type: "QR Customer",
    amount: 120.0,
  },
  {
    sl: 2,
    payment_type: "QR Customer",
    amount: 180.0,
  },
];

export const DataReservation = [
  {
    sl: 19,
    customer_name: "	Melody Macy",
    table: "4",
    NoPerson: "2",
    start_time: "22:00:00",
    end_time: "22:30:00",
    date: "23/11/2023",
    status: "Booked",
  },
  {
    sl: 20,
    customer_name: "John Doe",
    table: "1",
    NoPerson: "6",
    start_time: "12:00:00",
    end_time: "13:58:00",
    date: "23/11/2023",
    status: "Free",
  },
];

export const DataUnavailableDate = [
  {
    sl: 19,
    time: "22:00:00 - 22:30:00",
    date: "23/11/2023",
  },
];

export const DataCateringInquiry = [
  {
    sl: 1,
    name: "Ahmed",
    noPerson: "3",
    contact: "0112654654",
    Date: "2024-09-13",
    status: "Active",
  },
  {
    sl: 2,
    name: "Mohamed",
    noPerson: "2",
    contact: "0102654654",
    Date: "2024-07-17",
    status: "InActive",
  },
];


export const DataPurchase = [
  {
    sl: 19,
    invoice_no: 56235,
    customer_name: "Carrefour Dandy",
    date: "23/11/2023",
    price: 5000,
  },
  {
    sl: 20,
    invoice_no: 66124,
    customer_name: "John Doe",
    date: "24/7/2024",
    price: 3800,
  },
];

export const DataNewAward= [
  {
    sl: 19,
    customer_name: "Award Name",
    customer_des: "Award Description",
    g_name: "2",
    date: "23/11/2023",
    emp_name: 'Mostafa',
    award: 'Ahmed',
  },
];

export const DataSupplier = [
  {
    sl: 19,
    customer_name: "Carrefour Dandy",
    email: "Carrefour98@gmail.com",
    mobile: "0123456789",
    address: "Attaba",
    balance: 7500,
  },
  {
    sl: 20,
    customer_name: "John Doe",
    email: "John45@gmail.com",
    mobile: "0101234567",
    address: "Faisal",
    balance: 6150,
  },
];

export const DataDesignation= [
  {
    sl: 19,
    customer_name: "Operations Assistant	",
    email: "Coordinates orders, pos, expenses, menu, ingredients",
  },
  {
    sl: 20,
    customer_name: "Waiter	",
    email: "Most waiters and waitresses, also called servers, work in full-service restaurants. They greet customers, take food orders, bring food and drinks to the tables and take payment and make change.",
  },
];

export const DataProduction = [
  {
    sl: 19,
    food_name: "Biryani Rice - أرز برياني	",
    variant_name: "1 person",
    price: 5000,
  },
];


export const DataOutOf = [
  {
    int: "Ziti Pasta",
    qyt: 2.00,
  },
  {
    int: "Worcester Sauce",
    qyt: 0.00,
  },
  {
    int: "Wooden Chopstick",
    qyt: 3.00,
  },
  {
    int: "White Vinegar",
    qyt: 5.00,
  },
];

export const DataPurchaseReport = [
  {
    invoice: 19,
    customer_name: "Carrefour Dandy",
    Date:"25-5-2024",
    total: 7500,
  },
  {
    invoice: 20,
    customer_name: "John Doe",
    Date:"8-7-2024",
    total: 15000,
  },
];
export const DataVoucherReport = [
  {
    invoice: 'CV-BAC-2024-08-20',
    customer_name: "Aggregated Cash Credit Voucher of 2024-08-20	",
    Date:"25-5-2024",
    total: 1500,
  }
];
export const DataProfitLoss = [
  {
    customer_name: "Income",
    total: 84.56
    ,
  },
  {
    customer_name: "Expense",
    total: 888.00,
  }
];

export const DataCashBook = [
  {
    sl: '1',
    voucher_no: "56235",
    voucher_type: "PO",
    head: "Cash In Hand",
    Date:"25-5-2024",
    debit: 0,
    credit: 5000.00,
    balance: -5000.00,
  }
];

export const DataStockReport = [
  {
    food_name: "Oreo Milkshake - ميلك شيك أوريو",
    inqty:15,
    outaty:12,
    stock: 500,
  },
  {
    food_name: "White Basmati Rice - أرز بسمتي سادة",
    inqty:17,
    outaty:20,
    stock: 500,
  },
];
export const DataStockReportStation = [
  {
    food_name: "Basmati Rice",
    inqty:15,
    outaty:12,
    stock: 500,
  },
  {
    food_name: "Egyptian White Rice",
    inqty:17,
    outaty:20,
    stock: 500,
  },
];

export const DataSalesReport = [
  {
    invoice: 13757,
    customer_name: "Melody Macy",
    payment_method: "Cash Payment",
    order_date: "2024-07-09	",
    total_order: 1500,
    vat: 50,
    Service_charge: 80,
    Discount: 180,
    total_amount: 1450,
  },
  {
    invoice: 14878,
    customer_name: "John",
    payment_method: "Due Payment",
    order_date: "2024-01-08	",
    total_order: 3500,
    vat: 50,
    Service_charge: 80,
    Discount: 200,
    total_amount: 3430,
  },
];

export const DataItemsSalesReport = [
  {
    item: "item",
    variant_name: "variant_name",
    qty: "50",
    total_amount: 1450,
  }
];

export const DataItemsServiceChargeReport = [
  {
    order_id: 2,
    Service_charge: 80,
  },
  {
    order_id: 3,
    Service_charge: 120,
  }
];

export const DataItemsWaiter = [
  {
    order_id: "John",
    Service_charge: 1180,
  },
  {
    order_id: "Marco",
    Service_charge: 1220,
  }
];

export const DataItemsSalesByTable = [
  {
    order_id: "table 1",
    Service_charge: 225,
  },
  {
    order_id: "table 2",
    Service_charge: 125,
  }
];


export const DataItemStation = [
  {
    order_id: "Sandwiches",
    Service_charge: 1180,
  },
  {
    order_id: "BBQ",
    Service_charge: 1220,
  }
];

export const DataDeliveryType = [
  {
    order_id: "Pickup",
    Service_charge: 1180,
  },
  {
    order_id: "",
    Service_charge: 1220,
  }
];


export const DataItemsSalesReportByDate = [
  {
    food_name: 'Biryani Rice - أرز برياني',
    variant_name: '1 Person',
    date:'03-7-2024',
    Quantity:'1',
    price:80.00,
    total:80
  },
  {
    food_name: "Fettuccini Alfredo - فيتوشيني ألفريدو	",
    variant_name: '3 Person',
    date:'03-7-2024',
    Quantity:'2',
    price:195.00,
    total:195
  },
];


export const DataCommission = [
  {
    waiter: "John",
    total: 275,
    Commission:0
  },
  {
    waiter: "wiater 2",
    total: 255,
    Commission:0
  },
  {
    waiter: "wiater 3",
    total: 200,
    Commission:0
  },
];

export const DataItemsSalesReportFiltering = [
  {
    id: "0027",
    customer_name: "AL Fardous",
    waiter: "waiter",
    sales: "Online Customer",
    date: "2024-7-3",
    total_discount: 0,
    third_party: 0,
    total_amount: 95.76,
  },
  {
    id: "0028",
    customer_name: "AL Fardous",
    waiter: "waiter 2",
    sales: "Christina VANCE	",
    date: "2024-7-4",
    total_discount: 20,
    third_party: 0,
    total_amount: 212.30,
  },
];

export const DataItemsCashier = [
  {
    id: "0027",
    customer_name: "Super Admin",
    counter: "25",
    date: "2024-7-3",
    total_discount: 2000,
    third_party: 20000,
  }
];